import styled from 'styled-components/macro';

export const ListViewStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-x: auto;
  overflow-y: auto;

  ${({ theme }): string => `
    ${theme.devices.tablet} {
      border-radius: ${theme.radius.md};
    }
  `}
`;

export const ContentStyled = styled.div`
  height: 100%;
  min-height: 30vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 0.875rem 0 0;
  overflow-x: auto;

  ${({ theme }): string => `
    ${theme.devices.smallDesktop} {
      padding: 0.875rem 0 0;
    }
  `}
`;

export const ApprovedStyled = styled.div`
  ${({ theme }): string => `
    ${theme.devices.tablet} {
      margin-left: 20px; 
    }
  `}
`;

export const HasAttachmentStyled = styled.div`
  ${({ theme }): string => `
    ${theme.devices.tablet} {
      margin-left: 20px; 
    }
  `}
`;

export const BreakWordsContentStyled = styled.div`
  padding: 6px 0;
  ${({ theme }): string => `
    ${theme.devices.desktop} {
      word-break:  break-word; 
    }
  `}
`;
